/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  GetUserProfileQueryResponse,
  GetUserProfilePathParams,
  GetUserProfile401,
  GetUserProfile403,
  GetUserProfile404,
} from "../types/GetUserProfile.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { getUserProfile } from "../client/getUserProfile.ts"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getUserProfileQueryKey = (id: GetUserProfilePathParams["id"]) =>
  [{ url: "/users/:id/profile", params: { id: id } }] as const

export type GetUserProfileQueryKey = ReturnType<typeof getUserProfileQueryKey>

export function getUserProfileQueryOptions(
  id: GetUserProfilePathParams["id"],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getUserProfileQueryKey(id)
  return queryOptions<
    GetUserProfileQueryResponse,
    ResponseErrorConfig<
      GetUserProfile401 | GetUserProfile403 | GetUserProfile404
    >,
    GetUserProfileQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getUserProfile(id, config)
    },
  })
}

/**
 * @summary Get the profile of a user you follow
 * {@link /users/:id/profile}
 */
export function useGetUserProfile<
  TData = GetUserProfileQueryResponse,
  TQueryData = GetUserProfileQueryResponse,
  TQueryKey extends QueryKey = GetUserProfileQueryKey,
>(
  id: GetUserProfilePathParams["id"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUserProfileQueryResponse,
        ResponseErrorConfig<
          GetUserProfile401 | GetUserProfile403 | GetUserProfile404
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getUserProfileQueryKey(id)

  const query = useQuery(
    {
      ...getUserProfileQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetUserProfile401 | GetUserProfile403 | GetUserProfile404
    >
  > & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}
